export const address =
  'addr1q94n8nmp2zevcxq0rtf8manljastlvy4hr2m79e9hae8jrrzrkwt9hqexvvlj4clf8x329wqfrnr5tdacex437e75zwswqajck';
export const logoUrl = 'https://api.cdswap.io/logos/';
export const defCurrency = '...';
